function extractAttribute(tagMarkup, attributeName) {
  const pattern = new RegExp(`${attributeName}=(["'])(.*?)\\1`, "i");
  const match = tagMarkup.match(pattern);

  return match?.[2] || "";
}

function getFirstImageTag(post) {
  const html = post?.content?.rendered || post?.excerpt?.rendered || "";
  const match = html.match(/<img\b[^>]*>/i);

  return match?.[0] || "";
}

function getPlainTitle(post) {
  return (
    post?.title?.rendered?.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim() ||
    "Post image"
  );
}

export function getPostImageData(post) {
  const media = post?._embedded?.["wp:featuredmedia"]?.[0];
  const sizes = media?.media_details?.sizes;
  const preferredSize =
    sizes?.full ||
    sizes?.large ||
    sizes?.medium_large ||
    sizes?.medium ||
    sizes?.thumbnail ||
    null;

  if (
    sizes?.full?.source_url ||
    sizes?.large?.source_url ||
    sizes?.medium_large?.source_url ||
    sizes?.medium?.source_url ||
    media?.source_url
  ) {
    return {
      src:
        preferredSize?.source_url ||
        media?.source_url ||
        "",
      alt: media?.alt_text || getPlainTitle(post),
    };
  }

  const firstImageTag = getFirstImageTag(post);

  if (!firstImageTag) {
    return {
      src: "",
      alt: getPlainTitle(post),
    };
  }

  return {
    src: extractAttribute(firstImageTag, "src"),
    alt: extractAttribute(firstImageTag, "alt") || getPlainTitle(post),
  };
}

export function getPostImageUrl(post) {
  return getPostImageData(post).src || null;
}
